import { createFileRoute, redirect } from '@tanstack/react-router';
import moment from 'moment';

export const Route = createFileRoute('/weekplan/')({
  component: () => null,
  loader: async () => {
    throw redirect({
      to: '/weekplan/$year/$week/$day/{-$shiftId}',
      params: {
        year: moment().isoWeekYear().toString(),
        week: moment().isoWeek().toString(),
        day: moment().weekday().toString(),
      },
    });
  },
});
